import _ from 'lodash';
import * as Locales from 'date-fns/locale';

// constants
import {
  INITIAL_APP_LANGUAGE,
  LOCAL_TIMEZONE_LOCALE,
  PORTAL_LOCALSTORAGE_ACCESS_KEY
} from '../constants/constant';
import { loadFromLocalDB } from '../reducers/localStorage';

export default function useTimezoneInfo() {
  const [mainRegion, subRegion] = _.split(LOCAL_TIMEZONE_LOCALE, '-');
  const tzLocal = _.join(
    [mainRegion, ...(!_.isEmpty(subRegion) ? _.toUpper(subRegion) : '')],
    ''
  );

  const languageKey =
    loadFromLocalDB(PORTAL_LOCALSTORAGE_ACCESS_KEY.state)?.session?.language ??
    INITIAL_APP_LANGUAGE;
  const isInitAppLang = _.isEqual(INITIAL_APP_LANGUAGE, languageKey);

  const checkForLang =
    !isInitAppLang && languageKey && !_.isEmpty(Locales[languageKey]);
  const checkForTZ = tzLocal && !_.isEmpty(Locales[tzLocal]);

  const dateFnsLocale = checkForLang
    ? Locales[languageKey]
    : checkForTZ
    ? Locales[tzLocal]
    : Locales.en;

  return {
    rdKey: checkForLang
      ? languageKey
      : checkForTZ
      ? LOCAL_TIMEZONE_LOCALE
      : INITIAL_APP_LANGUAGE,
    dateFnsLocale
  };
}
